import {mapGetters, mapActions} from 'vuex';
import DownloadCsv from 'vue-json-csv';

// Stores
import * as DOCTOR from '@/store/constants/doctor';

// Mixins
import AuthUser from '@/mixins/authenticated-user';
import WithFilters from '@/mixins/with-filters';
import WithDateFilters from '@/mixins/with-date-filter';

// Modules.
import ListWithSpinner from '@/components/ListWithSpinner';
import SearchInput from '@/components/SearchInput';

export default {
  data() {
    return {
      name: 'DoctorList',
      fields: [
        {key: 'first_name', sortable: true},
        {key: 'last_name', sortable: true},
        'middle_name',
        'license_number',
        'field',
        'ptr_number',
        'year_of_service',
        'created_at'
      ],
      isProcessing: false
    }
  },
  components: {ListWithSpinner, SearchInput, DownloadCsv},
  mixins: [AuthUser, WithFilters, WithDateFilters],
  computed: {
    ...mapGetters({
      doctors: DOCTOR.GET_DOCTOR_LIST
    }),

    items() {
      return this.doctors.data;
    },

    /**
     * Is admin
     * @returns {boolean}
     */
    isAdmin() {
      return this.authUser.role.name === 'admin';
    }
  },

  methods: {
    ...mapActions({
      listDoctors: DOCTOR.ACTION_LIST_DOCTORS
    }),

    /**
     * View detail.
     *
     * @param item
     */
    viewDetail(item) {
      this.$router.push(
        {
          name: 'DoctorDetail',
          params: {id: item.id, doctor: item}
        }
      );
    },

    /**
     * Pull the dat.
     */
    refreshData() {
      this.isProcessing = true;

      let filters = this.formatFilters();

      if (this.wildcard) {
        filters = {...filters, ...{wildcard: this.wildcard}};
      }

      filters = {
        ...filters, ...{
          page: this.doctors.current_page,
          order_by: ['last_name,desc'],
        }
      };

      this.listDoctors(filters).finally(() => this.isProcessing = false);
    },

    /**
     * Filter list.
     * @param item
     */
    filterList(item) {
      this.wildcard = (item !== '') ? [`last_name|first_name,like,${item}`] : null;
      this.refreshData();
    },

    /**
     * Paginate
     */
    handlePaginate() {
      this.refreshData();
    },

    /**
     * Init
     */
    init() {
      this.refreshData();
    }
  },

  created() {
    this.listDoctors({
      order_by: ['last_name,desc']
    });
  }
}



// WEBPACK FOOTER //
// ./src/views/Doctor/js/list.js